function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import classNames from 'classnames';
import { withHotKeys } from 'react-hotkeys';
import Dropdown from '../containers/dropdown/Dropdown';
import NavList from '../navList/NavList';
import TextList from '../textList/TextList';
import DropLink from './_internal/DropLink';
import { ALIGN_LEFT } from '../containers/dropdown/constants';
import { getAdditionalProps } from '../utils/propTypes';
import { isMediumDown } from '../utils/mediaQueries';
import { ITEMS_PROP_TYPE } from '../navList/constants';
import { TEXT_ITEMS_PROP_TYPE } from '../textList/constants';
import { TABBABLE_INDEX, UNTABBABLE_INDEX, HIDE_CHILD, SHOW_CHILD } from '../hotKeys/constants';
import { ACTION_KEY_MAP } from './hotKeys';
var FOCUSED_POSITION = 0;
var UNFOCUSED_POSITION = -1;

var DropdownMenuList = function DropdownMenuList(_ref) {
  var show = _ref.show,
      navItems = _ref.navItems,
      textItems = _ref.textItems,
      align = _ref.align,
      dropUp = _ref.dropUp,
      onHide = _ref.onHide,
      onTextItemSelect = _ref.onTextItemSelect,
      defaultFocusPosition = _ref.defaultFocusPosition;
  var menu = null;
  var list;

  if (textItems) {
    list = React.createElement(TextList, {
      items: textItems,
      onItemSelect: onTextItemSelect,
      defaultFocusPosition: defaultFocusPosition
    });
  } else if (navItems) {
    list = React.createElement(NavList, {
      items: navItems,
      defaultFocusPosition: defaultFocusPosition
    });
  }

  if (show) {
    menu = React.createElement(Dropdown, {
      align: align,
      dropUp: dropUp,
      onClickOutside: onHide
    }, list);
  }

  return menu;
};

var DropdownMenu =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DropdownMenu, _React$PureComponent);

  function DropdownMenu() {
    var _getPrototypeOf2, _defineProperty2;

    var _this;

    _classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showDropdown: false,
      tabIndex: TABBABLE_INDEX,
      focusPosition: UNFOCUSED_POSITION,
      shouldFocusDropLink: false
    });

    _defineProperty(_assertThisInitialized(_this), "hotKeyHandlers", (_defineProperty2 = {}, _defineProperty(_defineProperty2, HIDE_CHILD, _this._hideDropdown.bind(_assertThisInitialized(_this), {
      shouldFocusDropLink: true
    })), _defineProperty(_defineProperty2, SHOW_CHILD, function (e) {
      return _this._showDropdown({
        shouldFocusChild: true,
        isKeyEvent: true
      }, e);
    }), _defineProperty2));

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "_hideDropdown",
    value: function _hideDropdown() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$shouldFocusDrop = _ref2.shouldFocusDropLink,
          shouldFocusDropLink = _ref2$shouldFocusDrop === void 0 ? false : _ref2$shouldFocusDrop;

      this.setState({
        showDropdown: false,
        tabIndex: TABBABLE_INDEX,
        focusPosition: UNFOCUSED_POSITION,
        shouldFocusDropLink: shouldFocusDropLink
      });
    }
  }, {
    key: "_showDropdown",
    value: function _showDropdown() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$shouldFocusChil = _ref3.shouldFocusChild,
          shouldFocusChild = _ref3$shouldFocusChil === void 0 ? false : _ref3$shouldFocusChil,
          _ref3$isKeyEvent = _ref3.isKeyEvent,
          isKeyEvent = _ref3$isKeyEvent === void 0 ? false : _ref3$isKeyEvent,
          _ref3$shouldFocusDrop = _ref3.shouldFocusDropLink,
          shouldFocusDropLink = _ref3$shouldFocusDrop === void 0 ? false : _ref3$shouldFocusDrop;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (isKeyEvent) {
        e.preventDefault();
        e.stopPropagation();
      }

      this.setState({
        showDropdown: true,
        tabIndex: isKeyEvent ? UNTABBABLE_INDEX : TABBABLE_INDEX,
        focusPosition: shouldFocusChild ? FOCUSED_POSITION : UNFOCUSED_POSITION,
        shouldFocusDropLink: shouldFocusDropLink
      });
    }
  }, {
    key: "_handleLinkClick",
    value: function _handleLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();
      var showDropdown = this.state.showDropdown;

      if (showDropdown) {
        this._hideDropdown();
      } else {
        this._showDropdown();
      }
    }
  }, {
    key: "_handleMouseOver",
    value: function _handleMouseOver() {
      this._showDropdown({
        shouldFocusDropLink: true
      });
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave() {
      this._hideDropdown({
        shouldFocusDropLink: false
      });
    }
  }, {
    key: "_handleTextItemSelect",
    value: function _handleTextItemSelect(value, index) {
      var onTextItemSelect = this.props.onTextItemSelect; // NOTE: Need to always hide the dropdown when an item is selected
      // regardless of if an `onTextItemSelect` handler is specified

      this._hideDropdown();

      if (onTextItemSelect) {
        onTextItemSelect(value, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fallbackUrl = _this$props.fallbackUrl,
          navItems = _this$props.navItems,
          textItems = _this$props.textItems,
          dropdownAlign = _this$props.dropdownAlign,
          dropUp = _this$props.dropUp,
          preventMouseOver = _this$props.preventMouseOver,
          hideDropIconWhenNarrow = _this$props.hideDropIconWhenNarrow;
      var _this$state = this.state,
          showDropdown = _this$state.showDropdown,
          tabIndex = _this$state.tabIndex,
          focusPosition = _this$state.focusPosition,
          shouldFocusDropLink = _this$state.shouldFocusDropLink;
      var className = classNames('eds-dropdown-menu', {
        'eds-dropdown-menu--active': showDropdown
      });
      var additionalProps = getAdditionalProps(this);

      var _handleMouseOver;

      var _handleMouseLeave; // maintain the hover-ability on desktop but there is no concept of hover on mobile
      // if the component mounts on a mobile/tablet sized window, we assume no hover


      if (!isMediumDown() && !preventMouseOver) {
        _handleMouseOver = this._handleMouseOver.bind(this);
        _handleMouseLeave = this._handleMouseLeave.bind(this);
      }

      return React.createElement("div", _extends({
        "data-spec": "dropdown-menu",
        role: "menubar",
        tabIndex: "-1"
      }, additionalProps, {
        className: className,
        onMouseOver: _handleMouseOver,
        onMouseLeave: _handleMouseLeave,
        onFocus: noop()
      }), React.createElement(DropLink, {
        fallbackUrl: fallbackUrl,
        dropUp: dropUp,
        onClick: this._handleLinkClick.bind(this),
        tabIndex: tabIndex,
        preventMouseOver: preventMouseOver,
        showDropdown: showDropdown,
        hideDropIconWhenNarrow: hideDropIconWhenNarrow,
        shouldFocusDropLink: shouldFocusDropLink
      }, children), React.createElement(DropdownMenuList, {
        show: showDropdown,
        navItems: navItems,
        textItems: textItems,
        align: dropdownAlign,
        dropUp: dropUp,
        defaultFocusPosition: focusPosition,
        onHide: this._hideDropdown.bind(this),
        onTextItemSelect: this._handleTextItemSelect.bind(this)
      }));
    }
  }]);

  return DropdownMenu;
}(React.PureComponent);

_defineProperty(DropdownMenu, "propTypes", {
  /**
   * The contents of link that activates the dropdown menu
   */
  children: PropTypes.node.isRequired,

  /**
   * The fallback URL for the link that activates the dropdown menu
   * (for a11y mostly)
   */
  fallbackUrl: PropTypes.string,

  /**
   * The text items to show in he dropdown menu
   */
  textItems: TEXT_ITEMS_PROP_TYPE,

  /**
   * The nav items to show in he dropdown menu
   */
  navItems: ITEMS_PROP_TYPE,

  /**
   * How the dropdown should be horizontally positioned relative to the link
   */
  dropdownAlign: Dropdown.propTypes.align,

  /**
   * Whether or not the dropdown should "drop up"
   */
  dropUp: Dropdown.propTypes.dropUp,

  /**
   * Whether or not to prevent the dropdown from showing on mouse over
   */
  preventMouseOver: PropTypes.bool,

  /**
   * Callback function that will be called when a list item is selected
   */
  onTextItemSelect: PropTypes.func,

  /**
   * Option to hide the chevron drop icon when narrow breakpoints are used
   */
  hideDropIconWhenNarrow: PropTypes.bool
});

_defineProperty(DropdownMenu, "defaultProps", {
  dropdownAlign: ALIGN_LEFT,
  dropUp: false,
  preventMouseOver: false,
  hideDropIconWhenNarrow: false
});

export default withHotKeys(ACTION_KEY_MAP)(DropdownMenu);